import { ForwardedRef, ReactNode, forwardRef, useRef } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { BodyText } from '@/common/components/BodyText/BodyText';
import * as TooltipPrimitive from '@rn-primitives/tooltip';
import { styles } from './Tooltip.styles';

export interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  delay?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
}

export const Tooltip = forwardRef(
  (
    {
      children,
      content,
      delay = 100,
      side = 'top',
      sideOffset = 8,
    }: TooltipProps,
    ref: ForwardedRef<TooltipPrimitive.TriggerRef>
  ) => {
    const container = useRef(
      Platform.OS === 'web'
        ? document.getElementById('primitives-root')
        : undefined
    );

    return (
      <TooltipPrimitive.Root delayDuration={delay}>
        <TooltipPrimitive.Trigger ref={ref}>
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal container={container.current} hostName="root">
          <TooltipPrimitive.Overlay
            closeOnPress
            style={StyleSheet.absoluteFill}
          >
            <TooltipPrimitive.Content
              side={side}
              sideOffset={sideOffset}
              className={styles.content}
            >
              <BodyText
                color="neutral10"
                size="sm"
                context="provider"
                className={styles.text}
              >
                {content}
              </BodyText>
            </TooltipPrimitive.Content>
          </TooltipPrimitive.Overlay>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    );
  }
);

Tooltip.displayName = 'Tooltip';
